import { formatShortDate } from "@clipboard-health/date-time";
import { isDefined } from "@clipboard-health/util-ts";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, IconButton, Stack } from "@mui/material";
import { useTu } from "@src/appV2/i18n/useTu";

interface DateToggleProps {
  selectedDate: Date;
  previousDate?: Date;
  nextDate?: Date;
  timezone?: string;
  disabled?: boolean;
  onSelectPreviousDate: () => void;
  onSelectNextDate: () => void;
}

export function DateToggle({
  selectedDate,
  previousDate,
  nextDate,
  timezone,
  disabled = false,
  onSelectPreviousDate,
  onSelectNextDate,
}: DateToggleProps) {
  const { tu } = useTu("common");
  const formatOptions = { timeZone: timezone };
  const selectedLabel = formatShortDate(selectedDate, formatOptions);

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
      <IconButton
        aria-label={
          isDefined(previousDate)
            ? `Select ${formatShortDate(previousDate, formatOptions)}`
            : tu("Previous day")
        }
        disabled={!isDefined(previousDate) || disabled}
        size="small"
        sx={{ padding: 0 }}
        onClick={onSelectPreviousDate}
      >
        <ChevronLeftIcon fontSize="small" />
      </IconButton>
      <Box
        component="span"
        sx={(theme) => ({ color: theme.palette.text.secondary, fontWeight: 500 })}
      >
        {selectedLabel}
      </Box>
      <IconButton
        aria-label={
          isDefined(nextDate)
            ? `Select ${formatShortDate(nextDate, formatOptions)}`
            : tu("Next day")
        }
        disabled={!isDefined(nextDate) || disabled}
        size="small"
        sx={{ padding: 0 }}
        onClick={onSelectNextDate}
      >
        <ChevronRightIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
}
